import React from 'react';

import { SvgProps } from './svg.type';

export const DashedLineGreen: React.FC<SvgProps> = (props) => (
    <svg
        width="132"
        height="132"
        viewBox="0 0 132 132"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M131 39C111.555 51.8458 71.9278 74.0496 1.49999 93"
            stroke="url(#paint0_linear_1378:766)"
            strokeWidth="2"
            strokeDasharray="4 4"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1378:766"
                x1="119.324"
                y1="12.0292"
                x2="-12.3724"
                y2="83.8082"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#94C987" />
                <stop offset="1" stopColor="#DCE9E2" />
            </linearGradient>
        </defs>
    </svg>
);
